export default {
  ONE_PAGE: 'one_page',
  FUNDRAISING: 'fundraising',
  CAMPAIGN: 'campaign',
  TEAM: 'team',
  UNKNOWN: 'unknown',
};
